<div class="content">
  <iu-storekeeper-window-input-scan
    [inventory]="true"
    (inventoryChange)="changeCurrentLine($event)"
    (validation)="save()" />

  @for (line of lines(); track line) {
    <iu-storekeeper-inventory-line
      [complete]="true"
      [data]="line"
      (dataChange)="changeLine($index, $event)"
      (remove)="removeLine($index, $event)" />
  }

  <iu-storekeeper-inventory-line
    #lastLine
    [complete]="false"
    [data]="currentLine()"
    (add)="addCurrentLine()"
    (cancel)="resetCurrentLine()"
    (dataChange)="changeCurrentLineQty($event)" />
</div>

<iu-storekeeper-navbar-button
  [icon]="'icon-circle-check'"
  [label]="'Confirm' | SKWTranslate"
  [type]="'confirm'"
  (onClick)="save($event)" />
